
document.addEventListener("ajaxloader:render", ctaPopupOpenEvent, {once:true});
document.addEventListener("DOMContentLoaded", ctaPopupOpenEvent, {once:true});
function ctaPopupOpenEvent(){
  $('a[href="#cta-form"]').click(function(){
    $('.cta_form').addClass('popup-show');

    var Notification = $(this).attr('notification');
    // console.log(Notification,'Notification');
    if (Notification) {
      $('.cta_form input[name="User From"]').val(Notification);
    }
  
    if ($(this).attr('current-product')) {
      var CurrentProductUrl = $(this).attr('current-product');
      var CurrentProductTitle = $(this).attr('product-title');
      
      // var GetCurrentProductTitle = CurrentProductUrl.split("/");
      // var CurrentProductTitle = GetCurrentProductTitle[2].replace(/-/g, " ");
      
      $('.cta_form input[name="Url"]').val('https://www.wearcomet.com' + CurrentProductUrl);
      $('.cta_form input[name="Title"]').val(CurrentProductTitle);
    }
  })
}

$('.cta_form .popup-close').click(function(){
  if($('.cta_form').hasClass('popup-show')){
     $('.cta_form').removeClass('popup-show');
  }

  setTimeout(() => {
    var ShowForm = document.getElementById('cta_form_tag');
    ShowForm.style.display="block";
    $('.cta_form .thank-you-message').hide();
    $('.cta_form #form-title').show();
    ShowForm.reset();
  }, "1000");
})  

$('.cta_forms.modal-overlay').click(function(){
  if($('.cta_form').hasClass('popup-show')){
     $('.cta_form').removeClass('popup-show');
  }

  setTimeout(() => {
    var ShowForm = document.getElementById('cta_form_tag');
    ShowForm.style.display="block";
    $('.cta_form .thank-you-message').hide();
    $('.cta_form #form-title').show();
    ShowForm.reset();
  }, "1000");
})   
  
window.addEventListener("load", function() {

// Update Variant
document.addEventListener('product:variant:changed',function(e){
  const data = e['detail'];
  if(data && data['variant']){
    const variant_name  = data['variant']['name'];
    window.wc_current_selected_variant = variant_name;
  }else{
    window.wc_current_selected_variant = null;
  }
  // console.log(window.wc_current_selected_variant);
});
});

function ctaForm(){
  const form = document.getElementById('cta_form_tag');
  form.addEventListener("submit", function(e) {
    e.preventDefault();
    document.querySelector("#cta_form_tag .submit-button").disabled = true;
    document.getElementById("popup-form-btn-loader").style.display = "block";
    document.getElementById("popup-form-btn-text").style.display = "none";
    const data = new FormData(form);

    // Update Variant Data
    if(window.wc_current_selected_variant){
      data.append('Variant Name' ,window.wc_current_selected_variant);
    }
    
    const action = e.target.action;
    fetch(action, {
      method: 'POST',
      body: data,
    })
    .then(() => {
        form.style.display="none";
        $('.cta_form .thank-you-message').show();
         document.getElementById("popup-form-btn-loader").style.display = "none";
         document.getElementById("popup-form-btn-text").style.display = "block";
         document.querySelector("#cta_form_tag .submit-button").disabled = false;
        $('#form-title').hide();
    })
  });
}

ctaForm();  
  